module.exports = __webpack_public_path__ + "static/media/bn_180.56eef36f.svg";